import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import config from '../../config';
import I18n from '../../lib/i18n';
import { fetchAvailableOptions } from '../../modules/AvailableOption';
import { availableServiceOptionsSelector, getCreditableOptionsWithPlan, getLocalCreditableOptionsWithPlan, hasRoamingCreditableOptions, } from '../../modules/AvailableOption/selectors';
import { isExemptedFromTaxSelector } from '../../modules/Customer/selectors';
import { isLineOFFSelector } from '../../modules/Dashboard';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import {
  isNewOfferValidSelector,
  newOfferPeriodicitySelector,
  newOfferPriceSelector,
} from '../../modules/NewOffer/selectors';
import { changePlan } from '../../modules/Subscription';
import {
  setCurrentVoucherDetails,
  voucherCurrentVoucherDetailsSelector,
  voucherFilteredAvailableVouchersSelector,
} from '../../modules/Voucher';
import ChangePlan from './ChangePlan';
import { has } from 'lodash';

const mapStateToProps = state => ({
  creditableOptions: config.displayRoamingPlanSliders
    ? getLocalCreditableOptionsWithPlan(state)
    : getCreditableOptionsWithPlan(state),
  serviceOptions: availableServiceOptionsSelector(state),
  price: newOfferPriceSelector(state),
  periodicity: newOfferPeriodicitySelector(state),
  disableNextButton: !isNewOfferValidSelector(state),
  buttonText: I18n.t('ChoosePlanDuringTurnBackOn.confirmButton'),
  confirmModalText: I18n.t('ChoosePlanDuringTurnBackOn.confirmModal'),
  isExemptedFromTax: isExemptedFromTaxSelector(state),
  isConfirmationLoading: isLoadingSelector(state, 'changePlanConfirmation'),
  isChangingPlanDuringTurnBackOn: true,
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
  displayVouchersForChangePlan: config.displayVouchersForChangePlan,
  filteredAvailableVouchers: voucherFilteredAvailableVouchersSelector(state),
  isLineOFF: isLineOFFSelector(state),
  hasRoamingOptions: hasRoamingCreditableOptions(state),
});



function mapDispatchToProps(dispatch, ownProps) {
  return {
    changePlan: () => dispatch(changePlan()),
    setCurrentVoucherDetails: (object: Object) => dispatch(setCurrentVoucherDetails(object)),
    fetchAvailableOptions: () => dispatch(fetchAvailableOptions(true)),
  };
}

const withOrderTypeProps = (): { orderType: string } => ({
  orderType: 'CHANGEPLAN',
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withProps(withOrderTypeProps()))(ChangePlan);
